import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _isUndefined from "lodash/isUndefined";
import _invoke from "lodash/invoke";
import cx from 'clsx';
import React, { Component } from 'react';
import { childrenUtils, createShorthandFactory, customPropTypes, getElementType, getUnhandledProps, SUI, useKeyOnly, useKeyOrValueAndKey, useValueAndKey } from '../../lib';
import Icon from '../Icon/Icon';
import Image from '../Image/Image';
import LabelDetail from './LabelDetail';
import LabelGroup from './LabelGroup';
/**
 * A label displays content classification.
 */

var Label = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Label, _Component);
  function Label() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleClick = function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    };
    _this.handleIconOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e) {
          _invoke(predefinedProps, 'onClick', e);
          _invoke(_this.props, 'onRemove', e, _this.props);
        }
      };
    };
    return _this;
  }
  var _proto = Label.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      active = _this$props.active,
      attached = _this$props.attached,
      basic = _this$props.basic,
      children = _this$props.children,
      circular = _this$props.circular,
      className = _this$props.className,
      color = _this$props.color,
      content = _this$props.content,
      corner = _this$props.corner,
      detail = _this$props.detail,
      empty = _this$props.empty,
      floating = _this$props.floating,
      horizontal = _this$props.horizontal,
      icon = _this$props.icon,
      image = _this$props.image,
      onRemove = _this$props.onRemove,
      pointing = _this$props.pointing,
      prompt = _this$props.prompt,
      removeIcon = _this$props.removeIcon,
      ribbon = _this$props.ribbon,
      size = _this$props.size,
      tag = _this$props.tag;
    var pointingClass = pointing === true && 'pointing' || (pointing === 'left' || pointing === 'right') && pointing + " pointing" || (pointing === 'above' || pointing === 'below') && "pointing " + pointing;
    var classes = cx('ui', color, pointingClass, size, useKeyOnly(active, 'active'), useKeyOnly(basic, 'basic'), useKeyOnly(circular, 'circular'), useKeyOnly(empty, 'empty'), useKeyOnly(floating, 'floating'), useKeyOnly(horizontal, 'horizontal'), useKeyOnly(image === true, 'image'), useKeyOnly(prompt, 'prompt'), useKeyOnly(tag, 'tag'), useKeyOrValueAndKey(corner, 'corner'), useKeyOrValueAndKey(ribbon, 'ribbon'), useValueAndKey(attached, 'attached'), 'label', className);
    var rest = getUnhandledProps(Label, this.props);
    var ElementType = getElementType(Label, this.props);
    if (!childrenUtils.isNil(children)) {
      return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), children);
    }
    var removeIconShorthand = _isUndefined(removeIcon) ? 'delete' : removeIcon;
    return /*#__PURE__*/React.createElement(ElementType, _extends({
      className: classes,
      onClick: this.handleClick
    }, rest), Icon.create(icon, {
      autoGenerateKey: false
    }), typeof image !== 'boolean' && Image.create(image, {
      autoGenerateKey: false
    }), content, LabelDetail.create(detail, {
      autoGenerateKey: false
    }), onRemove && Icon.create(removeIconShorthand, {
      autoGenerateKey: false,
      overrideProps: this.handleIconOverrides
    }));
  };
  return Label;
}(Component);
Label.handledProps = ["active", "as", "attached", "basic", "children", "circular", "className", "color", "content", "corner", "detail", "empty", "floating", "horizontal", "icon", "image", "onClick", "onRemove", "pointing", "prompt", "removeIcon", "ribbon", "size", "tag"];
export { Label as default };
Label.Detail = LabelDetail;
Label.Group = LabelGroup;
Label.create = createShorthandFactory(Label, function (value) {
  return {
    content: value
  };
});